import _groupBy from "lodash/groupBy";

const createLi = (name, { labels = {}, formatters = {}, filters = [] }, params = [], { seriesName, seriesType }) => {
  const filterList = [];

  filters.forEach((filter, i) => {
    if (filter.name) {
      const marker = params[i]?.marker ?? "";
  
      // TODO: Как добавиться график дописать логику для закрепления линии графика
      if (labels[seriesName] === labels[name]) {
        params[i]?.seriesType === seriesType
          ? filterList.push(`
          <li>
             ${ marker } <b>${ filter.name }: ${ formatters[name]?.(params[i]?.value) ?? params[i]?.value } ${ filter.notice }</b>
          </li>
      `)
          : filterList.push(`
          <li>
             ${ marker } ${ filter.name }: ${ formatters[name]?.(params[i]?.value) ?? params[i]?.value } ${ filter.notice }
          </li>
      `);
      } else {
        filterList.push(`
          <li>
             ${ marker } ${ filter.name }: ${ formatters[name]?.(params[i]?.value) ?? params[i]?.value } ${ filter.notice }
          </li>
      `);
      }
    }
  });

  return `
      <li>
        <p>${ labels[name] ?? name } </p>
        <ul>
          ${ filterList?.join("") }
        </ul>
      </li>`;
};

export const efficiencyTooltipBuilder = (params = [], tooltip = {}, event = {}) => {
  const title = params[0]?.name;
  const grouped = _groupBy(params, "seriesName");

  const userStats = [];
  for (const name in grouped) {
    userStats.push(createLi(name, tooltip, grouped[name], event));
  }

  return `
        <div class="chart-tooltip">
            <p class="chart-tooltip__title">${ title }</p>
            <ul class="chart-tooltip__list">
              ${ userStats.join("") }
            </ul>
        </div>
    `;
};
